/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
  const currentUrl = window.location.href;
  const urlSplit = currentUrl.split("/")
  const currentPage = urlSplit[urlSplit.length - 1]
  
  if (currentPage.includes('black-friday')) {
    const form = document.querySelector("#form")
    console.log(form)
    let stickyBuyButton = document.createElement('div');
    stickyBuyButton.className = 'sticky-buy-button';
    stickyBuyButton.style.justifyContent = "center"
    stickyBuyButton.innerHTML = '<a href="#form">Subscrever Lista VIP</a>';
    document.body.appendChild(stickyBuyButton);

     window.addEventListener('scroll', function() {
      let rect = form.getBoundingClientRect();
      if (rect.bottom < 0 ) {
        stickyBuyButton.style.display = 'flex';
      } else {
        stickyBuyButton.style.display = 'none';
      }
    });
  }

 (function () {
  console.log("I am from costume")
  window._shipScout = window._shipScout || [];
  var el = document.querySelector(".AnnouncementBar__Content");

  /*el.innerHTML =   el.innerHTML + `<br><small>📦Envio grátis para encomendas acima de 20€</small>`;*/

  /* This nex funciton is just for shipScout app, that is not active righ now */
  _shipScout.push(function (response) {

      /*
          example response object
          {
              testId: 1,
              testType: 'threshold',
              variant: 'B',
              threshold: true,
              freeShippingThresholdCents: 5000,
              shippingPriceCents: 1000,
              lineItemProperty: 0467e6f7-8d66-4610-a939-da76dd9f7a68_1_B
          }
      */

      //apply any exchange rates to currency if necessary
      var thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;
      var flatrateCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.shippingPriceCents * Shopify.currency.rate : response.shippingPriceCents;


      //format currency
      var currencyFormat = ShipScoutGetCurrency();

      //get threshold amount with currency symbol
      var thresholdAmount = ShipScoutFormatMoney(thresholdCents, currencyFormat);

      //get flat rate amount with currency symbol
      var flatrateAmount = ShipScoutFormatMoney(flatrateCents, currencyFormat);

      //==== insert your code below to dynamically update elements ====//

      //example updating an element on the page dynamically with the threshold amount

     /*  if(response.freeShippingThresholdCents === 0) {
          el.innerHTML = "Subscreve a nossa newsletter e tem 10% de DESCONTO 😀 Portes Grátis 🆓";
      } else {
          el.innerHTML = `Subscreve a nossa newsletter e tem 10% de DESCONTO 😀 <br><small>📦Envio grátis para encomendas acima de ${thresholdAmount}</small>`;
      } */

  });
})();

(function () {
  document.addEventListener("DOMContentLoaded", function() {
    console.log("I am bottom")
    var buyButton = document.querySelector('.ProductForm__AddToCart'); // Adjust this selector if your buy button has a different class
    var btntext = buyButton.innerText.split(/ /)[0]
    var productTitle = document.querySelector('.ProductMeta__Title').innerText; // Replace 'product-title-class' with the class of your product title
    var productPrice = document.querySelector('.ProductMeta__Price').innerText; // Replace 'product-price-class' with the class of your product price
    console.log(buyButton)
    var stickyBuyButton = document.createElement('div');
    stickyBuyButton.className = 'sticky-buy-button';
    stickyBuyButton.innerHTML = '<span class="sticky-product-title">' + productTitle + '</span> <span class="sticky-product-price">' + productPrice + '</span> <a href="#">' + btntext + '</a>';
    document.body.appendChild(stickyBuyButton);

    window.addEventListener('scroll', function() {
        var rect = buyButton.getBoundingClientRect();
        if (rect.bottom < 0 ) {
          var productPrice = document.querySelector('.ProductMeta__Price').innerText;
          stickyBuyButton.innerHTML = '<span class="sticky-product-title">' + productTitle + '</span> <span class="sticky-product-price">' + productPrice + '</span> <a href="#">' + btntext +'</a>';
            stickyBuyButton.style.display = 'flex';
        } else {
            stickyBuyButton.style.display = 'none';
        }
    });

    stickyBuyButton.querySelector('a').addEventListener('click', function(e) {
        e.preventDefault();
        buyButton.click();
        stickyBuyButton.style.display = 'none';
    });
});

})();

